const ideaBusinessQuestions = [
  {
    question: "Why do you believe in your Idea?",
    answer: "",
    placeholder:
      "If you want to raise money this point must be really clear. Tro to give us the value preposition here. How would your Idea solve a problem",
  },
  {
    question:
      "Who is the person to attend the Assessment Meeting for This Business. Include all Informaton",
    answer: "",
    placeholder:
      "The person to attend this meeting is Mr./ Miss. last name, first name. To reach them call 1-123-123-1234 their email is and the other information is...",
  },
  {
    question: "Do you know your target market?",
    answer: "",
    placeholder: "If not just write not yet",
  },
  {
    question:
      "What are your primary business objectives for the next year? (e.g., revenue growth, market expansion, profitability improvement)",
    answer:
      "Our main goal for the next year is to achieve a 20% growth in revenue through effective market expansion strategies.",
    placeholder: "We aim to expand our market and increase revenue by X%.",
  },
  {
    question: "What is your budget to carry on with this Target Dream?",
    answer:
      "I have this amount and I am seeking investment or I have plans to raise capital through",
    placeholder:
      "I have this amount and I am seeking investment or I have plans to raise capital through",
  },
  {
    question:
      "Have you tested your Idea or Thought about the Minimum Viable Product",
    answer:
      "We're targeting to onboard 1000 new customers and launch a new product line by the end of the year.",
    placeholder:
      "Not yet or yes we have and it is at the planning stage or out the door for testing",
  },
  {
    question: "Did you fill the Valuable Awareness Survey?",
    answer:
      "In the long term, we envision our business as a recognized leader in our industry, providing innovative solutions and maintaining a strong customer base.",
    placeholder:
      "The most important thing for me in this business is that people who have this problem should be taken care of at an affordable price",
  },
  {
    question:
      "Can you provide an overview of your current financial position? (e.g., annual revenue, expenses, profit)",
    answer:
      "Currently, our annual revenue stands at $2 million, with expenses of $1.5 million, resulting in a profit of $500,000.",
    placeholder:
      "Our financial overview includes an annual revenue of $X million, expenses of $Y million, and a profit of $Z million.",
  },
  {
    question:
      "Do you have any existing financial and business reports? (e.g., balance sheets, income statements)",
    answer:
      "Yes, we have comprehensive financial reports, including balance sheets and income statements, which we use to assess our financial health.",
    placeholder:
      "We maintain financial reports such as balance sheets and income statements to evaluate our financial health.",
  },
  {
    question: "What does success look like for your business in the long term?",
    answer:
      "In the long term, we envision our business as a recognized leader in our industry, providing innovative solutions and maintaining a strong customer base.",
    placeholder:
      "Success for us means becoming an industry leader known for innovation and customer satisfaction.",
  },
  {
    question: "What problems are you facing right now?",
    answer:
      "In the long term, we envision our business as a recognized leader in our industry, providing innovative solutions and maintaining a strong customer base.",
    placeholder:
      "We are starting at the Idea and Need help with Projections Statements, Business Plan, Marketing, or something else",
  },
  // ... (similarly, answers and placeholders for other questions)
  {
    question:
      "Is there anything else you'd like to share with us that you feel is important for the growth assessment?",
    answer: "",
    placeholder:
      "We value your insights. Please feel free to share any additional information that you think is relevant for our assessment.",
  },
];

export default ideaBusinessQuestions;
